import { combineReducers } from "redux";
import general from "./general";
import authentication from "./authentication";
import questions from "./questions";
import widget from "./widget";

const checkinApp = combineReducers({
    general,
    authentication,
    questions,
    widget
});

export default checkinApp;